import { defineComponent as _defineComponent } from 'vue'
import { formatPrice } from "@/helpers/transformation/price";
  import { onMounted, ref, watchEffect } from "vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'HouseTable',
  props: {
    houses: {
      type: Array,
      default: () => [],
    },
    initialSelectedHouseId: {
      type: String,
      default: null,
    },
  },
  emits: ["selectHouse"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;
  const emit = __emit;

  const tableHeaders = [
    "House Designs",
    "Bedrooms",
    "Bathrooms",
    "Living",
    "Size",
    "Price",
    "Actions",
    "",
  ];
  const selectedHouseId = ref<string | null>(props.initialSelectedHouseId);

  const onSelectHouse = (
    id: string,
    area: number,
    basePrice: number,
    floorplanUrl: string,
    floorplanName: string,
    houseName: string
  ) => {
    selectedHouseId.value = id;
    emit(
      "selectHouse",
      selectedHouseId.value,
      area,
      basePrice,
      floorplanUrl,
      floorplanName,
      houseName
    );
  };

  const getButtonLabel = (id: string) => {
    return selectedHouseId.value !== null && id !== selectedHouseId.value
      ? "Change"
      : "Select";
  };

  onMounted(() => {
    if (props.initialSelectedHouseId) {
      const house = props.houses.find(
        (h) => h._id === props.initialSelectedHouseId
      );

      if (house) {
        onSelectHouse(
          house._id,
          house.area,
          house.basePrice,
          house.floorplans[0].url,
          house.floorplans[0].name,
          house.name
        );
      }
    }
  });

const __returned__ = { props, emit, tableHeaders, selectedHouseId, onSelectHouse, getButtonLabel, get formatPrice() { return formatPrice }, onMounted, ref, watchEffect }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})